export interface RelativeDateGroup<T> {
  label: string
  items: T[]
}

// Calendar arithmetic, not fixed-millisecond offsets: a day is not always 24h, so subtracting
// N * 86_400_000 shifts every boundary by an hour across a DST transition and mislabels entries.
function startOfDayBefore(now: Date, days: number): number {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() - days).getTime()
}

export function relativeDateGroupLabel(date: string, now: Date = new Date()): string {
  const value = new Date(date).getTime()

  if (value >= startOfDayBefore(now, 0)) return 'Today'
  if (value >= startOfDayBefore(now, 1)) return 'Yesterday'
  if (value >= startOfDayBefore(now, 7)) return 'Last 7 days'
  if (value >= startOfDayBefore(now, 30)) return 'Last 30 days'

  return 'Older'
}

export function groupByRelativeDate<T>(
  items: T[],
  getDate: (item: T) => string,
  now: Date = new Date(),
): RelativeDateGroup<T>[] {
  const groups: RelativeDateGroup<T>[] = []

  for (const item of items) {
    const label = relativeDateGroupLabel(getDate(item), now)
    const current = groups[groups.length - 1]

    if (current?.label === label) {
      current.items.push(item)
      continue
    }

    groups.push({ label, items: [item] })
  }

  return groups
}
